import { useTranslation } from "react-i18next";
import { Box, Button, IconButton, Typography } from "@mui/material";

import { GinoCreditsData } from "../../api/services/ginoCredits";
import { GinoHeaderIcon, HistoryIcon } from "../../assets/icons/gino-icons";

import { GinoPlans, GinoPlansLoading } from "./GinoPlans";
import APP_ROUTES from "../../../../routers/routeConstants";
import { useNavigate } from "react-router-dom";

const GinoHeader = ({
  ginoCredits,
  isLoadingGinoCredits,
  errorGinoCredits,
  openCreditLeftModal,
  handleOpenCreditLeftModal,
  handleCloseCreditLeftModal,
  title,
}: {
  ginoCredits?: GinoCreditsData;
  isLoadingGinoCredits: boolean;
  errorGinoCredits?: Error | null;
  openCreditLeftModal: boolean;
  handleOpenCreditLeftModal: () => void;
  handleCloseCreditLeftModal: () => void;
  title?: JSX.Element;
}) => {
  const { t } = useTranslation("gino", { keyPrefix: "homePage" });
  const navigate = useNavigate();

  const handleNavigateToChatHistory = () => navigate(APP_ROUTES.GINO_CHAT_HISTORY);
  const handleTryPro = () => {
    navigate(APP_ROUTES.PLANS_OVERVIEW);
  };
  return (
    <Box component="header" sx={styles.container}>
      {title ? (
        title
      ) : (
        <Typography component="h2" sx={styles.title}>
          <GinoHeaderIcon />
          {t("gino")}
        </Typography>
      )}

      <Box sx={styles.plansContainer}>
        {isLoadingGinoCredits && !errorGinoCredits && <GinoPlansLoading />}
        {!isLoadingGinoCredits && !errorGinoCredits && ginoCredits && (
          <GinoPlans
            ginoCredits={ginoCredits}
            open={openCreditLeftModal}
            handleOnClickCreditLeft={handleOpenCreditLeftModal}
            handleCloseCreditLeftModal={handleCloseCreditLeftModal}
          />
        )}
      </Box>

      <Box sx={styles.actionsContainer}>
        <IconButton onClick={handleNavigateToChatHistory}>
          <HistoryIcon />
        </IconButton>
        <Button sx={styles.tryProButton} onClick={handleTryPro}>
          {t("tryPro")}
        </Button>
      </Box>
    </Box>
  );
};

export default GinoHeader;

const styles = {
  container: {
    display: "flex",
    flexWrap: { xs: "wrap", sm: "nowrap" },
    justifyContent: "space-between",
    alignItems: "center",
    height: "fit-content",
    gap: { xs: "16px", sm: "24px" },
  },
  plansContainer: {
    display: "flex",
    order: { xs: 2, sm: "unset" },
    width: { xs: "100%", sm: "auto" },
    justifyContent: { xs: "center", sm: "flex-start" },
  },
  title: {
    color: "var(--text-base-primary, #14151A)",
    fontFamily: "Montserrat",
    fontSize: "var(--typography-size-h6, 24px)",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "var(--typography-line-height-h6, 32px)",
    letterSpacing: "var(--typography-letter-spacing-h6, -0.3px)",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  tryProButton: {
    padding: "8px 24px",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    position: "relative",
    color: "transparent !important",
    background: "linear-gradient(90deg, #2C4DED 0%, #9D00EC 100%) !important",
    WebkitBackgroundClip: "text !important",
    borderRadius: "50px !important",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      padding: "1px", // Border width
      background: "linear-gradient(90deg, #2C4DED 0%, #9D00EC 100%)",
      WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
      borderRadius: "50px",
    },
  },
};
